import { ACCOUNT_INFO_DATA, PROD_SUBSCRIPTION, SOCIAL_ACCOUNT_DATA, ADD_ACCOUNT_DATA, DELETE_SOCIAL_ACCOUNT_DATA, SAVED_CARDS_DATA, WIDGET_ADDON_DATA, UGC_ADDON_DATA, ACCOUNT_CARD_DATA, PRODUCT_SUBSCRIPTION_CANCELANCELLATION, PRODUCT_CANCELANCELLATION_STATUS } from './keys'

const initialState = { accountInfo: null, productSubscriptions: null, socialAccounts: null, addAccount: null, savedCards: null, widgetAddon: null, ugcAddon: null, accountCardData: null, productCancellation: null, productCancellationStatus: false }

export default function reducer(state = initialState, action) {

    switch (action.type) {
        case ACCOUNT_INFO_DATA: {
            return { ...state, accountInfo: action.payload }
        }

        case PROD_SUBSCRIPTION: {
            return { ...state, productSubscriptions: action.payload }
        }

        case SOCIAL_ACCOUNT_DATA: {
            return { ...state, socialAccounts: action.payload }
        }

        case ADD_ACCOUNT_DATA: {
            return { ...state, addAccount: action.payload }
        }

        case DELETE_SOCIAL_ACCOUNT_DATA: {
            let newdata = state.socialAccounts;
            newdata.accountInformations = state.socialAccounts.accountInformations.filter((item) => { return item.ConnectedAccounts.id != action.payload.feedId })
            return { ...state, socialAccounts: newdata }
        }

        case SAVED_CARDS_DATA: {
            return { ...state, savedCards: action.payload }
        }

        case WIDGET_ADDON_DATA: {
            return { ...state, widgetAddon: action.payload }
        }

        case UGC_ADDON_DATA: {
            return { ...state, ugcAddon: action.payload }
        }

        case ACCOUNT_CARD_DATA: {
            return { ...state, accountCardData: action.payload }
        }

        case PRODUCT_SUBSCRIPTION_CANCELANCELLATION: {
            return { ...state, productCancellation: action.payload }
        }

        case PRODUCT_CANCELANCELLATION_STATUS: {
            return { ...state, productCancellationStatus: action.payload }
        }

        default:
            return { ...state }
    }
}
